<template>
  <Dialog
    v-model="visible"
    title="Archive Practice Product"
    dialog-type="error"
    dialog-size="small"
    :close-on-overlay="true"
    @close="handleClose"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
        <path d="M10 11v6"></path>
        <path d="M14 11v6"></path>
        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
      </svg>
    </template>

    <div class="delete-product-body">
      <p class="delete-dialog-message">
        Are you sure you want to archive <strong>{{ productName }}</strong>? You can restore it later from archived products.
      </p>
    </div>

    <template #footer>
      <ResponsiveButton
        button_type="outlined"
        built_in_theme="error"
        size="medium"
        display_name="Cancel"
        @click-button="handleClose"
      />
      <ResponsiveButton
        button_type="filled"
        built_in_theme="error"
        size="medium"
        display_name="Archive"
        @click-button="handleConfirm"
      />
    </template>
  </Dialog>
</template>

<script>
import { deleteMerchandise } from '@/api/markup';
import { notify } from '@/utils/notify';

export default {
  name: 'DeleteProductDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
    merchPayload: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue', 'deleted'],
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    productName() {
      return this.product?.name || '';
    },
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    async handleConfirm() {
      if (!this.product) return;

      const params = {
        clinic_id: this.merchPayload.clinic_id,
        customer_id: this.merchPayload.customer_id,
        account_type: this.merchPayload.account_type,
        merchandise_id: this.product.id,
      };

      try {
        await deleteMerchandise(params);
        notify({
          type: 'success',
          title: 'Product Archived',
          message: 'The product has been archived successfully.'
        });
        this.$emit('deleted', this.product);
      } catch (error) {
        console.error('Error deleting merchandise:', error);
        notify({
          type: 'error',
          title: 'Error',
          message: 'Failed to archive product. Please try again.'
        });
      } finally {
        this.handleClose();
      }
    },
  },
};
</script>

<style scoped>
.delete-product-body {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
}

.delete-dialog-message {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333;
  line-height: 20px;
  margin: 0;
}
</style>
